var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout-container"},[_c('div',{staticClass:"w-100 h-100 d-flex justify-content-center align-items-center"},[_c('h2',[_vm._v("Saindo...")])])])
}]

export { render, staticRenderFns }